import { ImportantDates } from "commonAssets/components/ImportantDates";
import { Page } from "commonAssets/pages/Page";
import { appLocale, outputDiv, i18n, userLanguage, siteInfo } from "../../../common/assets/js/constants";
import { createElement, loadingGif, toggleFieldError, validateField, modal, clearMessage } from "../../../common/assets/js/helpers";
// import { SubmitClaim } from "../../../common/assets/js/submit-claim";
import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";

export class customImptDates extends ImportantDates {
    dateTime(params) {
        const date = new Date(params).toLocaleString(appLocale, {
            timeZone: "America/New_York",
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZoneName: 'short'
        });
        return date;
    }
}